<template>
  <div class="content">
    <el-row type="flex" justify="center">
      <el-col>
        <el-form
          label-position="top"
          label-width="80px"
          :rules="rules"
          ref="form"
          :model="form"
        >
          <el-form-item label="中文套餐名称" prop="lang_list[1].name">
            <el-input
              v-model="form.lang_list[1].name"
              placeholder="请输入中文套餐名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="英文套餐名称" prop="lang_list[0].name">
            <el-input
              v-model="form.lang_list[0].name"
              placeholder="请输入英文套餐名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="套餐类型" prop="type">
            <el-select v-model="form.type" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="价格" prop="price">
            <el-input placeholder="请输入价格" v-model="form.price"></el-input>
          </el-form-item>
          <el-form-item label="点数" prop="vip_point">
            <el-input
              placeholder="请输入点数"
              v-model="form.vip_point"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="可获得奖励代数"
            prop="can_receive_reward_gene_num"
          >
            <el-input
              placeholder="请输入可获得奖励代数"
              v-model="form.can_receive_reward_gene_num"
            ></el-input>
          </el-form-item>
          <el-form-item label="对应SHOPLAZZA商品ID" prop="product_id">
            <el-input
              placeholder="请输入SHOPLAZZA商品ID"
              v-model="form.product_id"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="center">
              <el-button @click="back"> 返回</el-button>
              <el-button type="primary" @click="store" :loading="btnLoading"
                >提交
              </el-button>
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      options: [
        {
          value: 'franchise_a',
          label: '加盟套餐A',
        },
        {
          value: 'active_a',
          label: '活跃套餐A',
        },
        {
          value: 'franchise_b',
          label: '加盟套餐B',
        },
        {
          value: 'active_b',
          label: '活跃套餐B',
        },
      ],
      btnLoading: false,
      rules: {
        'lang_list[0].name': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        'lang_list[1].name': [
          {
            required: true,
            message: '该项不能为空，请输入',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入套餐名称',
            trigger: 'change',
          },
        ],
        type: [
          {
            required: true,
            message: '请选择套餐类型',
            trigger: 'change',
          },
        ],
        price: [
          {
            required: true,
            message: '请输入价格',
            trigger: 'change',
          },
        ],
        vip_point: [
          {
            required: true,
            message: '请输入点数',
            trigger: 'change',
          },
        ],
        can_receive_reward_gene_num: [
          {
            required: true,
            message: '请输入奖励代数',
            trigger: 'change',
          },
        ],
        product_id: [
          {
            required: true,
            message: '请输入SHOPLAZZA商品ID',
            trigger: 'change',
          },
        ],
      },
      form: {
        type: '',
        name: '',
        price: '',
        vip_point: '',
        lang_list: [
          {
            lang: 'en_US',
            title: '',
          },
          {
            lang: 'zh-CN',
            title: '',
          },
        ],
        can_receive_reward_gene_num: '',
      },
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id
      this.detail()
    }
  },
  methods: {
    store() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/vipProduct/store',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.$router.push({
                path: '/member/membershipplan',
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    back() {
      this.$router.back()
    },
    detail() {
      request({
        url: '/api/backend/vipProduct/detail',
        method: 'get',
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = res.data
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
</style>
